import {Component} from 'react';
import h from 'react-hyperscript';
import './Form.scss';
import content from 'Assets/data/survey-question-ranking.json';
import {withStyles} from '@material-ui/core/styles';
import {p, footnote, subhead} from 'Components/Typography/Typography';
import {getIndexByProperty} from 'Src/utils/utils';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = (theme) => ({
  root: {
    'color': '#80868b',
    '&:hover': {
      color: '#1a73e8',
    },
    '&$checked': {
      color: '#1a73e8',
    },
  },
  checked: {},
});

class SurveyRadioGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultValue: '',
    };
  }

  componentDidMount() {
    this.checkIfValueExists();
  }

  componentDidUpdate(prevProps) {
    if (this.props.surveyValues !== prevProps.surveyValues) {
      this.checkIfValueExists();
    }
  }

  checkIfValueExists() {
    const i = getIndexByProperty(
        this.props.surveyValues.progress,
        'name',
        this.props.id
    );
    if (i >= 0) {
      this.setDefaultValue(this.props.surveyValues.progress[i].value);
    }
  }

  setDefaultValue(value) {
    this.setState({
      defaultValue: value,
    });
  }

  render() {
    return (
      h('div', {
        className: 'form-group form-group__radio--horizontal',
      }, [
        h(subhead, {
          id: `radio-subhead--${this.props.index}`,
          key: `radio-subhead--${this.props.index}`,
        }, `${this.props.index + 1}. ${this.props.title}`),

        h(p, {
          id: `radio-desc--${this.props.index}`,
          key: `radio-desc--${this.props.index}`,
          className: 'text--grey padding-bottom--md',
        }, this.props.desc),

        h('div', {
          id: `radio-labels--${this.props.index}`,
          className: 'flex--space-between--all',
        }, [
          h('div', {
            className: 'flex--space-between--all rating-labels',
          }, [
            h(footnote, {
              className: 'text--grey',
            }, 'Area of Growth'),
            h(footnote, {
              className: 'text--grey',
            }, 'Not Started')]),
          h('div', {
            className: 'flex--space-between--all rating-labels',
          }, [
            h(footnote, {
              className: 'text--grey',
            }, 'Area of Mastery'),
            h(footnote, {
              className: 'text--grey',
            }, 'Completed')]),
        ]),

        h(RadioGroup, {
          key: this.props.id,
          id: this.props.id,
          arialabel: this.props.name,
          name: this.props.name,
          value: this.state.defaultValue,
          onChange: this.props.onChange,
          datastep: this.props.step,
          className: 'radio-group--horizontal',
        }, [
          content.levels.map((radio, i) => {
            return (
              h(FormControlLabel, {
                key: radio.id,
                value: radio.value,
                label: radio.title,
                labelPlacement: 'bottom',
                control: h(Radio, {
                  inputProps: {
                    datastep: this.props.step,
                  },
                  classes: {
                    root: this.props.classes.root,
                    checked: this.props.classes.checked,
                  },
                }, null),
              })
            );
          }),
        ]),
      ])
    );
  }
}

export default withStyles(styles)(SurveyRadioGroup);
